import Api from '@/api/api'

export default {
    getZone() {
        return Api.get('SaasAdmin/Zone/GetZones')
    },
    getZoneById(id) {
        return Api.get('SaasAdmin/Feature/GetFeatureById?id=' + id)
    },
    addZone(data) {
        return Api.post('SaasAdmin/Zone/AddZone', data)
    },
    updateZone(id, data) {
        return Api.put('SaasAdmin/Zone/UpdateZone?id=' + id, data)
    },
    removeZone(id) {
        return Api.delete('SaasAdmin/Zone/DeleteZone?id=' + id)
    }
}